import { Lock } from "lucide-react";

// fix-broker-portal — brokers still climbing the certification ladder
// (Prospect / Qualified / Onboarding) can't reach the library or deal
// submission yet. Rather than letting the broker endpoints 403 with the
// raw "Broker session required." message, the Files and Deals tabs
// short-circuit to this friendly notice that frames the lock as a step in
// onboarding and points the broker at their status in the top bar.
export function BrokerLockedNotice({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <section
      aria-label={title}
      className="flex flex-col gap-space-4"
      data-testid="broker-locked-notice"
    >
      <div>
        <h2 className="text-h4 font-display text-onyx m-0">{title}</h2>
      </div>
      <div className="p-space-5 border border-border-light rounded-md bg-white-warm/40 flex items-start gap-space-3">
        <span className="shrink-0 mt-[2px] text-gold" aria-hidden>
          <Lock size={20} strokeWidth={1.5} />
        </span>
        <div>
          <p className="text-small text-onyx m-0">{description}</p>
          <p className="text-caption text-gray-mid m-0 mt-space-2">
            This unlocks once you've completed onboarding and your account is certified.
            You can follow your progress from the broker status in the top bar.
          </p>
        </div>
      </div>
    </section>
  );
}
